import React from 'react'
import styles from './index.module.less'
import { ProductConfig, ProductDetailInfo } from './interface'
import ProductInfo from './components/product'
import { getGoodList } from '@/apis/share'
import { currencySymbolMap, LangEum } from '@/constant'
import { env } from 'process'
import { cdnSrcResize } from '@/utils/cdn'
import { formatMoney } from '@/utils'
interface IProps {
  uid?: string
  editConfig: {
    lang: string
    local: string
  }
  propsConfig: {
    products: ProductDetailInfo[]
    initLine: number
    isShowTop: boolean
    hotTopCount: number
  }
  pageId
  CName
}
interface IState extends ProductConfig {
  productsDetail: ProductDetailInfo[]
  lineType: boolean
  initLine: number
  showMoreButton: boolean
  renderStatus: boolean
}

export const viewMore = {
  zh: '查看更多',
  'zh-TW': '查看更多',
  [LangEum['zh-MO']]: '查看更多',
  [LangEum['zh-TW2']]: '查看更多',
  en: `view more `,
  ja: '更に見る',
  [LangEum['zh-SG']]: '查看更多',
  [LangEum['zh-MY']]: '查看更多',
}

class PoizonARowGoods extends React.PureComponent<IProps, IState> {
  sliceIndex = 0
  allproductsDetail = []
  renderStatus = false

  static config: {
    name: string
    noSsr: boolean
  }

  constructor(props: IProps) {
    super(props)

    if (!props && env.NODE_ENV === 'development') {
      console.log('props数据加载失败，请debug')
      return
    }
    if (!props.propsConfig) return
    const { products, initLine, ...propArg } = props.propsConfig
    if (!products) return

    this.allproductsDetail = products || []

    const lineType = initLine === 0 ? false : true

    this.state = {
      ...propArg,
      productsDetail: products ? this._loadMoreData(lineType, initLine, 0) : [],
      lineType,
      initLine,
      showMoreButton: this.showMoreButton(),
      renderStatus: false,
    }
  }

  async componentDidMount() {
    await this.clientGetData()
  }

  // 客户端第一次渲染
  clientGetData = async () => {
    const { lineType, initLine } = this.state

    const { lang, local } = this.props.editConfig
    const spuIds = this.allproductsDetail.map(({ spuId }, index) => {
      return { spuId, index }
    })
    const {
      data: { children: data },
    } = await getGoodList({
      spuIdInfo: JSON.stringify(spuIds),
      countryCode: local,
      language: lang,
    })

    const validIdArr: number[] = data.map((item) => +item.spuId)

    const currency = this.handleCurrency()

    this.allproductsDetail = this.allproductsDetail
      .filter((item) => {
        return validIdArr.indexOf(item.spuId) !== -1
      })
      .map((item) => {
        const index = validIdArr.indexOf(item.spuId)
        item.priceShow = formatMoney(data[index].price)
        item.currency = currency

        return {
          ...data[index],
          ...item,
          title: data[index].title,
        }
      })

    const productsDetail = this._loadMoreData(lineType, initLine, 0)

    const showMoreButton = this.showMoreButton()
    this.setState({
      productsDetail,
      showMoreButton,
      renderStatus: true,
    })
  }

  // 点击加载更多
  loadMoreData = () => {
    const { lineType, initLine } = this.state
    return this._loadMoreData(lineType, initLine)
  }

  handleCurrency = () => {
    const local = this.props.editConfig.local
    return currencySymbolMap[local]
  }

  // 初始化第一次展示的列表
  _loadMoreData(lineType: boolean, initLine: number, forceNum?: number): ProductDetailInfo[] {
    let { sliceIndex } = this
    if (forceNum !== undefined) {
      sliceIndex = forceNum
    }

    if (!lineType) {
      return this.allproductsDetail
    }
    const currentProductsDetail = this.allproductsDetail.slice(0, sliceIndex + initLine)
    this.sliceIndex = sliceIndex + initLine

    this.setState({
      productsDetail: currentProductsDetail,
      showMoreButton: this.sliceIndex < this.allproductsDetail.length,
    })

    return currentProductsDetail
  }

  // 判断是否展示加载更多按钮
  showMoreButton = () => {
    return this.sliceIndex < this.allproductsDetail.length
  }

  render() {
    const { productsDetail, lineType, showMoreButton, isShowTop, hotTopCount, renderStatus } =
      this.state || {}
    const {
      pageId,
      CName,
      uid,
      editConfig: { lang },
    } = this.props || {}
    const arrow = cdnSrcResize(
      'https://cdn.poizon.com/node-common/1a1042d04c6ae1186ae7e30f9ea60604.png',
      28
    )
    if (!productsDetail || !renderStatus) return <div></div>

    console.log('lang===>', lang)

    return (
      <div className={styles.wrapper}>
        {productsDetail.map((productInfo, index) => {
          return (
            <ProductInfo
              {...productInfo}
              key={`${productInfo.spuId} + ${index}`}
              commonProps={{ pageId, CName, uid }}
              index={index + 1}
              showTopTip={isShowTop && hotTopCount >= index + 1}
            />
          )
        })}
        {lineType && showMoreButton ? (
          <div
            className={styles.morebox}
            onClick={() => {
              this.loadMoreData()
            }}
          >
            <span>{viewMore[lang]}</span>
            <img className={styles['icon-more']} src={arrow} alt="" />
          </div>
        ) : null}
      </div>
    )
  }
}

PoizonARowGoods.config = {
  name: 'poizon-a-row-goods',
  noSsr: false,
}

export default PoizonARowGoods
